import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsRecordFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 18.82C8.26 18.82 5.1 15.7 5.1 11.96C5.1 8.22 8.26 5.1 12 5.1C15.74 5.1 18.9 8.22 18.9 11.96C18.9 15.7 15.74 18.82 12 18.82Z" />
    </SvgIcon>
  );
});
